import { render, staticRenderFns } from "./ValidateRegistration.vue?vue&type=template&id=e10ad96c&"
import script from "./ValidateRegistration.vue?vue&type=script&lang=js&"
export * from "./ValidateRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ValidateRegistration.vue?vue&type=style&index=0&id=e10ad96c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports